import { IonList, IonLabel, IonIcon, IonItem } from '@ionic/react';
import { FC } from 'react';

interface MenuPage {
  title: string;
  icon: string;
  path: string;
  badge?: number;
  selected: string;
  id?: string;
  external?: boolean;
  target?: string;
}

interface MenuListSectionProps {
  className?: string;
  pages: MenuPage[];
  signOut: () => void;
  goToManageSubscription?: () => void;
  goToAppTour?: () => void;
  onRouteChange: () => void;
  id?: string;
  onExternalLink?: (url: string) => void;
}

const MenuListSection: FC<MenuListSectionProps> = ({
  className,
  pages,
  signOut,
  goToManageSubscription,
  goToAppTour,
  onRouteChange,
  id = '',
  onExternalLink,
}) => {
  const isFreePlayCredit = true;
  const isRedeemed = false;

  return (
    <IonList lines="none" className={`menu-list${className ? ` ${className}` : ''}`}>
      {pages
        .filter((route) => route.path != null)
        .map((page) => {
          if (page.external && page.target === '_blank' && typeof page.path === 'string') {
            return (
              <IonItem key={page.title} id={id} button onClick={() => {
                if (onExternalLink) {
                  onExternalLink(page.path);
                } else {
                  window.open(page.path, '_blank', 'noopener,noreferrer');
                }
                if (onRouteChange) onRouteChange();
              }}>
                <IonLabel className="lbl-white">
                  <IonIcon icon={page.icon} className="sidemenu-icon" />
                  <span className="sidemenu-text">{page.title}</span>
                </IonLabel>
              </IonItem>
            );
          }
          if (page.path === '/logout') {
            return (
              <IonItem key={page.title} id={id} onClick={signOut}>
                <IonLabel className="lbl-white">
                  <IonIcon icon={page.icon} className="sidemenu-icon" />
                  <span className="sidemenu-text">{page.title}</span>
                </IonLabel>
              </IonItem>
            );
          } 
          if (page.path === '/apptour') {
            return (
              <IonItem key={page.title} id={id} onClick={goToAppTour}>
                <IonLabel className="lbl-white">
                  <IonIcon icon={page.icon} className="sidemenu-icon" />
                  <span className="sidemenu-text">{page.title}</span>
                </IonLabel>
              </IonItem>
            );
          }
          if (page.path === '/billing') {
            return (
              <IonItem key={page.title} id={id} onClick={goToManageSubscription}>
                <IonLabel className="lbl-white">
                  <IonIcon icon={page.icon} className="sidemenu-icon" />
                  <span className="sidemenu-text">{page.title}</span>
                </IonLabel>
              </IonItem>
            );
          }
          else {
            return (
              <IonItem key={page.title} id={id} routerLink={page.path} onClick={onRouteChange} detail={false}>
                <IonLabel className="lbl-white">
                  <IonIcon icon={page.icon} className="sidemenu-icon" />
                  <span className="sidemenu-text">{page.title}</span>

                  {page?.title === 'Free Play' &&
                    isFreePlayCredit === true &&
                    isRedeemed === false && <span className="notification-bubble">1</span>}
                </IonLabel>
              </IonItem>
            );
          }
        })}
    </IonList>
  );
};

export default MenuListSection;
